module.exports = __webpack_public_path__ + "img/item5.77323bc4.png";